import createPlugin, { LazyComponentsMap, PluginConstructorParams } from './create-plugin';

type ThemeConstructorParams = PluginConstructorParams & {
    page: LazyComponentsMap['page']
}

export default function createTheme({ page, ...others }: ThemeConstructorParams) {
    return createPlugin({
        components: {
            ...others.components,
            page,
        },
        ...others
    });
}
